<div
  #nodeWrapper
  class="node-wrapper with-add-buttons"
  [class.focused]="focused()"
  [class.root]="locationSequence.isRoot()"
  [class.first-level]="locationSequence.getLevel() === 1"
  [class.add-buttons-open]="addButtonsOpen()"
  [class.simple-root]="rootTooltip && locationSequence.isRoot()"
  (click)="nodeState.nodeClick($event, locationSequence)"
  data-cy="hierarchy-node-wrapper"
  dtHierarchyNodeDrag
  dtHierarchyNodeDrop
  [dtHoverPopover]="nodeHover"
  [dtHoverPopoverDisableClick]="true"
  [dtHoverPopoverPosition]="'top'"
  [dtHoverPopoverDelay]="500"
  [dtHoverPopoverDisabled]="!(rootTooltip && locationSequence.isRoot())"
>
  <ng-container
    *ngTemplateOutlet="
      interface.nodeTemplate;
      context: {
        $implicit: tree.value,
        locationSequence,
        focused: singleFocused(),
      }
    "
  ></ng-container>

  <ng-template #nodeHover>
    <div class="node-hover-container mat-elevation-z3">
      {{ rootTooltip }}
    </div>
  </ng-template>

  @if (!singleFocused()) {
    <div class="click-capturing-overlay"></div>
  }

  @if (!interface.readonly) {
    <div class="add-buttons">
      <button mat-mini-fab color="accent" (click)="add($event, 'above')" class="add top">
        <mat-icon>add</mat-icon>
      </button>
      <button mat-mini-fab color="accent" (click)="add($event, 'right')" class="add right">
        <mat-icon>add</mat-icon>
      </button>
      <button mat-mini-fab color="accent" (click)="add($event, 'below')" class="add bottom">
        <mat-icon>add</mat-icon>
      </button>
      <button mat-mini-fab color="accent" (click)="add($event, 'left')" class="add left">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div class="tools">
      <button data-cy="add-button-opener" mat-flat-button color="accent" (click)="addButtonsOpen.set(true)">
        <mat-icon>add</mat-icon>
      </button>
      @if (!locationSequence.isRoot()) {
        <button data-cy="delete-button" class="delete" mat-flat-button color="accent" (click)="delete()">
          <mat-icon>delete</mat-icon>
        </button>
      }
    </div>
  }
</div>
